// extracted by mini-css-extract-plugin
export default {"maxHeight":"maxHeight--immUV"};